import type { StaffRole } from '@ucp/web/lib';

/**
 * Insights lens role arrays (PRO-0590, ADR-038), extracted from `InsightsSurface`
 * into this dependency-light module so the route guard in `AppRoutes` and the
 * eagerly-loaded landing resolver (`landingRoute.ts`) can import them WITHOUT
 * pulling the (now lazy-loaded) `InsightsSurface` and its lens views into the
 * initial bundle. `InsightsSurface` re-exports these for back-compat.
 */
export const ENTERPRISE_ROLES: StaffRole[] = ['CEO', 'COO', 'OPS_DIRECTOR'];
// PRO-0610 / ADR-038 A1 — SCHOOL_STAFF joins the School lens (baseline subset).
export const SCHOOL_ROLES: StaffRole[] = ['PRINCIPAL', 'OPS_DIRECTOR', 'SCHOOL_STAFF'];
// The Student placeholder stays gated to the full-lens viewers (SCHOOL_STAFF excluded).
export const STUDENT_ROLES: StaffRole[] = ['CEO', 'COO', 'OPS_DIRECTOR', 'PRINCIPAL'];
// The outer Insights module guard (AppRoutes) — the union of every lens's roles, so
// a SCHOOL_STAFF caller can reach the module and land on the School lens.
export const INSIGHTS_ROUTE_ROLES: StaffRole[] = [
  'CEO',
  'COO',
  'OPS_DIRECTOR',
  'PRINCIPAL',
  'SCHOOL_STAFF',
];
